module.exports = __webpack_public_path__ + "static/img/4areaA_11.8ec4ad5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_11.png
// module id = 897
// module chunks = 1